import { ApolloClient } from '@apollo/client'
import { compact, keyBy, omit } from 'lodash'
import { TestRegistrationKey, UserInfo } from '../../../api'
import { getUserInfo } from './get-user-info'
import { listTestRegistrationKeys } from './list-test-registration-keys'
import { retrieveTestRegistrationKey } from './retrieve-test-registration-key'

export type UserKeyInfo = UserInfo & Pick<TestRegistrationKey, 'id'>

export async function fetchKeysAndUsers(
  isAdmin: boolean,
  client: ApolloClient<unknown>,
): Promise<UserKeyInfo[]> {
  const testRegistrationKeys = isAdmin
    ? await listTestRegistrationKeys(client)
    : [await retrieveTestRegistrationKey(client)]

  const userNames = testRegistrationKeys.map((regTestKey) => regTestKey.owner)
  const userInfos = await getUserInfo(client, userNames)
  const userInfosBySub = keyBy(compact(userInfos), 'sub')

  const mappedKeys = testRegistrationKeys.map((testRegistrationKey) => {
    if (!userInfosBySub[testRegistrationKey.owner]) return undefined

    return {
      ...omit(testRegistrationKey, 'owner', 'publicKey'),
      ...userInfosBySub[testRegistrationKey.owner],
    }
  })

  return compact(mappedKeys)
}
